import ModalCustom from "components/ModalCustom"
import ActionFooterModalCard from "components/ModalCustom/ActionFooterModalCard"
import { useEffect, useState } from "react"
import { closeModal, openModal } from "reducers/modal"
import { configureStore } from "stores/configureStore"
import FormInputCard from "pages/auth/molecules/FormInputCard"
import SelectMulti from "components/Select/SelectMulti"
import NoDataCard from "pages/project-build/molecules/NoDataCard"
import { postAssignProjectToGroupsOrganizationMiddleware } from "pages/groups/groups.api"
import { closeLoading, startLoading } from "reducers/loading"
import {
  addRoleGroupOrganizationMiddleware,
  handleUserShareKeyProjectMiddleware,
} from "../services/api"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { toast } from "react-toastify"
import { encryptionController } from "controllers/EncryptionController"
import { ActivityLogType, activityLogHelper } from "helpers/activity_log"
import { postActionLogMiddleware } from "components/activity-log/activity-log.api"

interface AssignToUserModalProps {
  isOpen: boolean
  projectDecrypted: string
  users: {
    id: string
    fullname: string
    email: string
  }[]
  onClose: () => void
  projectId: string
  callback: () => void
}

export const AssignToUserModal = (props: AssignToUserModalProps) => {
  const { onClose, projectId, users, callback, isOpen, projectDecrypted } =
    props

  const [selectedOrganization, setSelectedOrganization] = useState<
    {
      label: string
      value: string
    }[]
  >([])

  useEffect(() => {
    if (!isOpen) {
      return
    }
    setSelectedOrganization([])
  }, [isOpen])

  const onSubmit = () => {
    configureStore.dispatch(
      openModal({
        type: "Delete",
        props: {
          deleteModal: {
            title: (
              <p>
                Adding this project to a user will update its associations
                immediately.
              </p>
            ),
            label: `Warning`,
            content: `This action cannot be undone.`,
            onSubmit: async () => {
              try {
                configureStore.dispatch(startLoading())
                for (const el of selectedOrganization) {
                  try {
                    await postAssignProjectToGroupsOrganizationMiddleware({
                      project_id: projectId,
                      user_id: el.value,
                    })
                    const content = await encryptionController().encrypt(
                      activityLogHelper.toLogMessage(
                        ActivityLogType.AssignProjectToUser,
                        {
                          userName: el.label.split(" - ")[1],
                        }
                      ),
                      {
                        dataType: "string",
                        type: "project",
                        encryptionKey: projectDecrypted,
                      }
                    )
                    await postActionLogMiddleware(
                      {
                        content: content,
                        created_by: localStorage.getItem("user_id") || "",
                        model: "projects",
                        relation_id: projectId,
                      },
                      true
                    )
                  } catch (error) {}
                }
                await handleUserShareKeyProjectMiddleware(
                  false,
                  true,
                  JSON.stringify([projectId]),
                  undefined,
                  JSON.stringify(selectedOrganization.map((el) => el.value))
                )
                await addRoleGroupOrganizationMiddleware({
                  is_share_all_project: false,
                  project_ids: JSON.stringify([projectId]),
                  user_ids: JSON.stringify(
                    selectedOrganization.map((el) => el.value)
                  ),
                })
                closeModal()
                onClose()
                closeLoading()
                callback()
                toast(
                  <LabelNotificationPage
                    messenger="Add project to user successfully!"
                    type="success"
                  />
                )
              } catch (error: any) {
                closeModal()
                closeLoading()
                toast(
                  <LabelNotificationPage
                    messenger="Add project to user failed!"
                    type="error"
                  />
                )
              }
            },
            styleTitle: { textAlign: "center" },
            titleButton: "Continue",
            colorYellowButton: true,
          },
        },
      })
    )
  }

  return (
    <ModalCustom
      label="Add user"
      widthModal={500}
      handleChangeButton={() => onClose}
      bodyChildren={
        <div className="flex flex-col">
          {users.length ? (
            <>
              <div className="grid grid-cols-1 gap-2 mb-[24px]">
                <FormInputCard title="Users" fontWeightText="font-semibold">
                  <SelectMulti
                    options={users.map((el) => ({
                      label: `${el.fullname} - ${el.email}`,
                      value: el.id,
                    }))}
                    selectedOption={selectedOrganization}
                    handleChange={setSelectedOrganization}
                    noOptionsMessage
                  />
                </FormInputCard>
              </div>
              <ActionFooterModalCard
                onCloseModal={onClose}
                onSubmit={onSubmit}
                handleDisableButton={!selectedOrganization.length}
                titleButton="Add"
              />
            </>
          ) : (
            <NoDataCard label="No users found" />
          )}
        </div>
      }
    />
  )
}
